import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import user from '../Img/user.png';
import ExpenseModal from './ExpenseModal';
import OfferingModal from './OfferingModal';
import CouponModal from './CouponModal';
import PlanModal from './PlanModal';
import UpdateModal from './UpdateModal';
import BranchModal from './BranchModal';
import ClassAgeGroupModal from './ClassAgeGroupModal';
import ClassLevelModal from './ClassLevelModal';
import ClassScheduleModal from './ClassScheduleModal';
import ReceivedPaymentModal from './ReceivedPaymentModal';
import DuePaymentModal from './DuePaymentModal';
import AddProject from './AddProject';
import CryptoJS from "crypto-js";
import axios from 'axios';
import { requestFCMToken } from './utils/firebaseUtils';

const Header = () => {
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [isQuickCreateOpen, setQuickCreateOpen] = useState(false);
    const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
    const quickCreateRef = useRef(null);
    const profileMenuRef = useRef(null);
    const [isExpenseOpen, setIsExpenseOpen] = useState(false);
    const [isOfferingOpen, setIsOfferingOpen] = useState(false);
    const [isCouponOpen, setIsCouponOpen] = useState(false);
    const [isPlanOpen, setIsPlanOpen] = useState(false);
    const [isUpdateOpen, setIsUpdateOpen] = useState(false);
    const [isBranchOpen, setIsBranchOpen] = useState(false);
    const [isAgeGroupOpen, setIsAgeGroupOpen] = useState(false);
    const [isClassLevelOpen, setIsClassLevelOpen] = useState(false);
    const [isClassScheduleOpen, setIsClassScheduleOpen] = useState(false);
    const [isReceivedFeesOpen, setIsReceivedFeesOpen] = useState(false);
    const [isDueFeesOpen, setIsDueFeesOpen] = useState(false);
    const [isActivityOpen, setIsActivityOpen] = useState(false);
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    // const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12")) || ""
    const login = "hello"
    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return decodeURIComponent(match[2]);
        return null;
    };

    const encryptedUser = getCookie("gta_mainstateuser");

    if (encryptedUser) {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedUser, "76677NAV");
            const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

            if (!decryptedText) throw new Error("Decryption produced empty string");

            const user = JSON.parse(decryptedText);
            console.log(user)
        } catch (error) {
            console.error("❌ Decryption failed:", error);
        }
    } else {
        console.warn("⚠️ No cookie found for gta_mainstateuser");
    }




    const navigate = useNavigate();
    // Function to toggle Quick Create menu
    const toggleQuickCreate = () => {
        setQuickCreateOpen(prevState => !prevState);
        setProfileMenuOpen(false); // Close profile menu if open
    };

    // Function to toggle Profile menu
    const toggleProfileMenu = () => {
        setProfileMenuOpen(prevState => !prevState);
        setQuickCreateOpen(false); // Close quick create menu if open
    };

    // Close menus if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                quickCreateRef.current && !quickCreateRef.current.contains(event.target) &&
                !event.target.closest('.quick-create')
            ) {
                setQuickCreateOpen(false);
            }
            if (
                profileMenuRef.current && !profileMenuRef.current.contains(event.target) &&
                !event.target.closest('.header-profile')
            ) {
                setProfileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const handlelogout =  () => {

    //         // Clear localStorage as well
    //         localStorage.removeItem("2xgxgshdugyywerw12gh");

    //         // Optional: redirect or reload
    //         navigate("/login");
    //         // window.location.href = "/login"; // Or navigate to login

    // };


    const handlelogout = async () => {
        try {
            const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
            const token = await requestFCMToken(); // Or store it globally

            if (login?.user_id && token) {
                await axios.post(`${process.env.REACT_APP_LINK}/firebase/unregister-token`, {
                    user_id: login.user_id,
                    deviceToken: token
                });
            }

            localStorage.removeItem("2xgxgshdugyywerw12gh");
            navigate("/login");
            // redirect or clean state
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    return (
        <>
            <div className={`header ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="header-list hamburger-search">
                    <div className="header-hamburger" onClick={toggleSidebar}>
                        <i className="fas fa-bars"></i>
                    </div>
                    {/* <div className="search-container">
                        <input type="text" placeholder="Search..." />
                        <i className="fas fa-search search-icon"></i>
                    </div> */}
                </div>
                <div className="header-list header-list2">
                    {/* <div className="notification">
                        <i className="fa-regular fa-bell"></i>
                    </div> */}
                    {/* <div className="quick-create">
                        <button onClick={toggleQuickCreate}>Quick create</button>
                    </div>
                    {isQuickCreateOpen && (
                        <div className="quick-create-menu" ref={quickCreateRef}>
                            <Link to='/add-customer-2'><button>+ Customer</button></Link>
                            <Link to='/new-invoice'><button>+ Invoice</button></Link>
                            <button onClick={() => setIsOfferingOpen(true)}>+ Offerings</button>
                            <button onClick={() => setIsCouponOpen(true)}>+ Coupon</button>
                            <button onClick={() => setIsPlanOpen(true)}>+ Plan</button>
                            <button onClick={() => setIsUpdateOpen(true)}>+ Update</button>
                            <button onClick={() => setIsExpenseOpen(true)}>+ Expense</button>
                            <button onClick={() => setIsBranchOpen(true)}>+ Branch</button>
                            <button onClick={() => setIsAgeGroupOpen(true)}>+ Age Group</button>
                            <button onClick={() => setIsClassLevelOpen(true)}>+ Class Level</button>
                            <button onClick={() => setIsClassScheduleOpen(true)}>+ Class Schedule</button>
                            <button onClick={() => setIsReceivedFeesOpen(true)}>+ Received Fees</button>
                            <button onClick={() => setIsDueFeesOpen(true)}>+ Due Fees</button>
                            <button onClick={() => setIsActivityOpen(true)}>+ Activity</button>
                        </div>
                    )} */}
                    <div className="header-profile" onClick={toggleProfileMenu}>
                        <div className="profile-img">
                            <img src={user} alt="User Profile" />
                        </div>
                        {isProfileMenuOpen && (
                            <div className="profile-menu" ref={profileMenuRef}>
                                <ul>
                                    {/* <li><i className="fa fa-user"></i> Profile</li> */}
                                    <li onClick={handlelogout}><i className="fa fa-sign-out-alt"></i> Logout</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modals */}
            <ExpenseModal isOpen={isExpenseOpen} setIsOpen={setIsExpenseOpen} title="Expense Modal" />
            <OfferingModal isOpen={isOfferingOpen} setIsOpen={setIsOfferingOpen} title="Offering Modal" />
            <CouponModal isOpen={isCouponOpen} setIsOpen={setIsCouponOpen} title="Coupon Modal" />
            <PlanModal isOpen={isPlanOpen} setIsOpen={setIsPlanOpen} title="Plan Modal" />
            <UpdateModal isOpen={isUpdateOpen} setIsOpen={setIsUpdateOpen} title="Update Modal" />
            <BranchModal isOpen={isBranchOpen} setIsOpen={setIsBranchOpen} title="Branch Modal" />
            <ClassAgeGroupModal isOpen={isAgeGroupOpen} setIsOpen={setIsAgeGroupOpen} title="Age Group Modal" />
            <ClassLevelModal isOpen={isClassLevelOpen} setIsOpen={setIsClassLevelOpen} title="Class Level Modal" />
            <ClassScheduleModal isOpen={isClassScheduleOpen} setIsOpen={setIsClassScheduleOpen} title="Class Schedule Modal" />
            <ReceivedPaymentModal isOpen={isReceivedFeesOpen} setIsOpen={setIsReceivedFeesOpen} title="Received Fees Modal" />
            <DuePaymentModal isOpen={isDueFeesOpen} setIsOpen={setIsDueFeesOpen} title="Due Fees Modal" />
            <AddProject isOpen={isActivityOpen} setIsOpen={setIsActivityOpen} title="Activity Modal" />
        </>
    );
};

export default Header;
